
import { HealthcareDepartment } from '@/contexts/AppContext';

export const healthcareTitles = [
  'Registered Nurse (RN)',
  'Licensed Practical Nurse (LPN)', 
  'Certified Nursing Assistant (CNA)',
  'Physician',
  'Nurse Practitioner',
  'Physician Assistant',
  'Pharmacist',
  'Pharmacy Technician',
  'Lab Technician',
  'Medical Technologist',
  'Radiologic Technologist',
  'Medical Assistant',
  'Administrative Staff',
  'Department Manager',
  'Supervisor',
  'Other'
];

export const healthcareDepartments: { value: HealthcareDepartment; label: string }[] = [
  { value: 'nursing', label: 'Nursing' },
  { value: 'emergency', label: 'Emergency Department' },
  { value: 'icu', label: 'Intensive Care Unit' },
  { value: 'pharmacy', label: 'Pharmacy' },
  { value: 'laboratory', label: 'Laboratory' },
  { value: 'radiology', label: 'Radiology' },
  { value: 'administration', label: 'Administration' },
  { value: 'other', label: 'Other' }
];
